import React from 'react';
import PropTypes from "prop-types";

import './skeleton.scss'

export function SkeletonImage(
  {
    width = '100%',
    height = '200px'
  }: {
    width?: string | number,
    height?: string | number
  }
) {
  return (
    <div
      className="placeholder-image placeholder-animated-background "
      style={{width: width, height: height}}
    />);
}

SkeletonImage.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
};

export default SkeletonImage;
